"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _identity = _interopRequireDefault(require("lodash/identity"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _Modal = _interopRequireDefault(require("./Modal"));
var _index = require("../index");
var _excluded = ["isOpen", "closeModal", "onCancel", "title", "onConfirm", "confirmButtonText", "cancelButtonText", "children", "automationHook"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  /** Wether or not the modal is open */
  isOpen: _propTypes["default"].bool.isRequired,
  /** Function that closes the confirmation modal - will usually set some state in the parent component that would then reflect in the isOpen prop passed above */
  closeModal: _propTypes["default"].func.isRequired,
  /** Title for the modal, will be a Heading1 component. If you don't pass one it is not added in. */
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  /** Callback to be called if the cancel button is clicked */
  onCancel: _propTypes["default"].func,
  /** Callback to be called if the confirm button is clicked */
  onConfirm: _propTypes["default"].func,
  /** Text on the cancel button
   * @default Cancel
   */
  cancelButtonText: _propTypes["default"].string,
  /** Text on the confirm button
   * @default Confirm
   */
  confirmButtonText: _propTypes["default"].string,
  /** Content for the modal that goes under the title if there is one */
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  /** Hook used for automation testing */
  automationHook: _propTypes["default"].string
};
var ConfirmationModal = function ConfirmationModal(_ref) {
  var isOpen = _ref.isOpen,
    closeModal = _ref.closeModal,
    _ref$onCancel = _ref.onCancel,
    onCancel = _ref$onCancel === void 0 ? _identity["default"] : _ref$onCancel,
    title = _ref.title,
    onConfirm = _ref.onConfirm,
    confirmButtonText = _ref.confirmButtonText,
    cancelButtonText = _ref.cancelButtonText,
    children = _ref.children,
    automationHook = _ref.automationHook,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], _extends({
    isOpen: isOpen,
    onRequestClose: closeModal,
    w: "400px",
    verticalPosition: "center",
    automationHook: automationHook
  }, rest), title && /*#__PURE__*/_react["default"].createElement(_Modal["default"].Box, null, /*#__PURE__*/_react["default"].createElement(_index.Heading1, {
    mB: "none"
  }, title)), children && /*#__PURE__*/_react["default"].createElement(_Modal["default"].Box, {
    pT: "none"
  }, children), /*#__PURE__*/_react["default"].createElement(_Modal["default"].Footer, null, /*#__PURE__*/_react["default"].createElement(_index.SecondaryButton, {
    onClick: function onClick() {
      onCancel.apply(void 0, arguments);
      closeModal.apply(void 0, arguments);
    },
    automationHook: (0, _automationHooks.getHook)(automationHook, "cancel-button")
  }, cancelButtonText || "Cancel"), /*#__PURE__*/_react["default"].createElement(_index.DangerButton, {
    onClick: function onClick() {
      onConfirm();
      closeModal();
    },
    automationHook: (0, _automationHooks.getHook)(automationHook, "confirm-button")
  }, confirmButtonText || "Confirm")));
};
ConfirmationModal.propTypes = propTypes;
var _default = ConfirmationModal;
exports["default"] = _default;